import { dataHighSquare } from 'dls-icons-data'
import { createIcon } from '../common'

const IconHighSquare = /*#__PURE__*/createIcon(dataHighSquare)
export default IconHighSquare
